import React from 'react';

import { constants, formatMailtoContent, locale } from '@trqk/utils';
import { IconInfoCircle } from '@trqk/components';

const { SUPPORT_EMAIL_ADDRESS } = constants;

/**
 * @typedef {UploadAudioErrorInput}
 * @property {object} errorDetails any JSON.stringify-able object
 */
interface UploadAudioErrorInput {
    errorDetails: Record<string, unknown>;
}

/**
 * A toast message shown when audio upload fails.
 */
export const UploadAudioError = ({
    input,
}: ToastRenderContentProps<UploadAudioErrorInput>): JSX.Element => {
    const errorDetails = input?.errorDetails ?? {};
    const bodyLines = [
        locale.enUS.UPLOAD_AUDIO.TOASTS.GENERAL_ERROR.REPORT_ISSUE_EMAIL.BODY
            .GREETING,
        locale.enUS.UPLOAD_AUDIO.TOASTS.GENERAL_ERROR.REPORT_ISSUE_EMAIL.BODY
            .PART_1,
        locale.enUS.UPLOAD_AUDIO.TOASTS.GENERAL_ERROR.REPORT_ISSUE_EMAIL.BODY
            .SIGN_OFF,
        '',
        '----------',
        `Error details: \n\n${JSON.stringify(errorDetails, null, 4)}`,
    ];

    const mailtoContent = formatMailtoContent({
        email: SUPPORT_EMAIL_ADDRESS,
        subject:
            locale.enUS.UPLOAD_AUDIO.TOASTS.GENERAL_ERROR.REPORT_ISSUE_EMAIL
                .SUBJECT,
        bodyLines,
    });

    return (
        <div style={{ width: 500 }} className="px-2">
            <div className="font-bold text-highlight-orange tracking-wider mb-1">
                {locale.enUS.UPLOAD_AUDIO.TOASTS.UPLOAD_ISSUE}
            </div>
            <div className="my-2 font-semibold">
                {locale.enUS.UPLOAD_AUDIO.TOASTS.GENERAL_ERROR.PART_1}
            </div>
            <div className="my-2">
                {locale.enUS.UPLOAD_AUDIO.TOASTS.GENERAL_ERROR.PART_2}
            </div>
            <div className="text-sm italic mt-6 mb-4 flex items-center">
                <IconInfoCircle
                    fillColor="tertiary-300"
                    width={20}
                    addClasses="mr-1"
                />
                {locale.enUS.UPLOAD_AUDIO.TOASTS.GENERAL_ERROR.REPORT_ISSUE}
                &nbsp;
                <a className="text-primary-500 underline" href={mailtoContent}>
                    {SUPPORT_EMAIL_ADDRESS}
                </a>
            </div>
        </div>
    );
};
